import React, { useReducer, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Select, Spin, message } from "antd";
import { useFetch } from "../../../Utils/useFetch";
import axios from "axios";
import {
  FETCH_ALL_DOWNLOADLINK_API,
  FETCH_ALL_DEPT_API,
} from "../../../Constants/Apis";
import { reducer } from "../../../Utils/CommonUtils";
import DownloadTable from "../../elements/Tables/DownloadTable/DownloadTable";

const { Option } = Select;

const StockReportPage = ({ history }) => {
  const initialState = {
    searchKeyword: "",
    departmentFilter: "",
    dateRange: {},
    filteredInfo: {},
    sorter: {},
    disabledUntil: null,
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const {
    fetchedData: { data: deptData = [] },
  } = useFetch(FETCH_ALL_DEPT_API, state);

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(FETCH_ALL_DOWNLOADLINK_API, state);

  const handleFetch = async () => {
    if (!state.departmentFilter) return;

    // Disable the button for 5 minutes
    const disableUntil = Date.now() + 5 * 60 * 1000;
    dispatch({ type: "disabledUntil", payload: disableUntil });

    try {
      const response = await axios.get(
        `https://ims-stock-ten.vercel.app/download`,
        {
          params: { pipeline_type: state.departmentFilter },
        }
      );
      message.success(
        response?.data?.message || "Download triggered successfully."
      );
    } catch (err) {
      console.log(err);
      message.error(
        err.response?.data?.message ||
          "Failed to trigger download. Please try again."
      );
    }
  };
  
  useEffect(() => {
    if (!state.disabledUntil) return;

    const now = Date.now();
    const remainingTime = state.disabledUntil - now;

    if (remainingTime <= 0) {
      dispatch({ type: "disabledUntil", payload: null });
      return;
    }

    const timer = setTimeout(() => {
      dispatch({ type: "disabledUntil", payload: null });
    }, remainingTime);

    return () => clearTimeout(timer);
  }, [state.disabledUntil]);

  return (
    <Spin spinning={loading}>
      <div
        style={{
          width: "100vw",
          padding: "20px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h5>Data will only be available until 3 days</h5>
        <h5>
          Only click download once, it will take some time (3-5 minutes) before
          the data shows in the table below (need to manually refresh)
        </h5>

        <div
          style={{
            paddingBottom: "20px",
            display: "flex",
            justifyContent: "center",
            gap: "16px",
            width: "80vw",
            maxWidth: "100vw",
          }}
        >
          <Select
            value={state.departmentFilter}
            placeholder="Select Department"
            style={{ width: "200px" }}
            onChange={(value) => {
              dispatch({ type: "departmentFilter", payload: value });
            }}
            disabled={loading}
          >
            <Option value="">All Departments</Option>
            {deptData.map((dept) => (
              <Option key={dept._id} value={dept.name}>
                {dept.name}
              </Option>
            ))}
          </Select>

          <Button
            type="primary"
            onClick={handleFetch}
            disabled={
              !state.departmentFilter ||
              loading ||
              (state.disabledUntil && Date.now() < state.disabledUntil)
            }
          >
            Fetch Data
          </Button>
        </div>

        <DownloadTable
          history={history}
          loading={loading}
          data={data}
          callReFetch={callReFetch}
          dispatch={dispatch}
        />
      </div>
    </Spin>
  );
};

StockReportPage.propTypes = {
  history: PropTypes.object,
};

export default StockReportPage;
